import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BabafeszkelokurzusModule } from './babafeszkelokurzus/babafeszkelokurzus.module';
import { AdatkezelesComponent } from './components/adatkezeles/adatkezeles.component';
import { AszfComponent } from './components/aszf/aszf.component';
import { GyikComponent } from './components/gyik/gyik.component';
import { LostPasswordComponent } from './components/lost-password/lost-password.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { RefreshComponent } from './components/refresh/refresh.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SigninComponent } from './components/signin/signin.component';
import { SignupComponent } from './components/signup/signup.component';
import { SuccessComponent } from './components/success/success.component';
import { UpdateProfileComponent } from './components/update-profile/update-profile.component';
import { FoglalkozasokbpModule } from './foglalkozasokbp/foglalkozasokbp.module';
import { FooldalModule } from './fooldal/fooldal.module';
import { AdminGuard } from './guards/admin.guard';
import { UserGuard } from './guards/user.guard';
import { KurzusModule } from './kurzus/kurzus.module';
import { KurzusoldalComponent } from './kurzus/kurzusoldal/kurzusoldal.component';
import { LombikrafelkeszitokurzusModule } from './lombikrafelkeszitokurzus/lombikrafelkeszitokurzus.module';
import { RolamModule } from './rolam/rolam.module';
import { TutorialModule } from './tutorial/tutorial.module';
import { VideotarModule } from './videotar/videotar.module';

const routes: Routes = [
  {path: '', loadChildren: () => FooldalModule},
  {path: 'signin', component: SigninComponent},
  {path: 'signup', component: SignupComponent},
  {path: 'success', component: SuccessComponent},
  {path: 'lost-password', component: LostPasswordComponent},
  {path: 'reset-password', component: ResetPasswordComponent},
  {path: 'gdpr', component: AdatkezelesComponent},
  {path: 'aszf', component: AszfComponent},
  {path: 'GYIK', component: GyikComponent},
  {path: 'fooldal', loadChildren: () => FooldalModule},
  {path: 'babafeszkelo-kurzus', loadChildren: () => BabafeszkelokurzusModule},
  {path: 'lombikra-felkeszito-kurzus', loadChildren: () => LombikrafelkeszitokurzusModule},
  {path: 'foglalkozasok-teremben', loadChildren: () => FoglalkozasokbpModule},
  {path: 'u', loadChildren:() => import('./user/user.module').then(u =>u.UserModule), canActivate: [UserGuard]},
  {path: 'admin' , loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule), canActivate: [AdminGuard]},
  {path: '', loadChildren: () => import('./elofizetes/elofizetes.module').then(e => e.ElofizetesModule)},
  {path: 'rolam', loadChildren: () => RolamModule},
  {path: 'tutorial-video', loadChildren: () => TutorialModule},
  {path: 'videotar', loadChildren:() => VideotarModule},
  {path: 'kurzusok/:title', loadChildren: () => KurzusModule},
  {path: 'kurzusaloldal/:urlParam', component: KurzusoldalComponent},
  {path: 'update-profile', component: UpdateProfileComponent},
  {path: 'not-found', component: NotFoundComponent},
  {path: 'refresh', component: RefreshComponent},
  {path: ':urlParam', component: KurzusoldalComponent},
  {path: '**', component: RefreshComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
